module.exports = __webpack_public_path__ + "img/email-icons-white-color-958812.34933997.jpg";